/**
 *  objectFromEntries<T> が、tuple型からの変換を行おうとすると、
 * 自明にkeyの型が` key in Tuple[number]`のはずが、stringとして扱われてしまうため
 * ラップ的に処理を作成する
 * @param tuple {string[]}
 * @param value {string}
 */
export const objectFromTupleAndValue = <T extends readonly string[], U>(tuple: T, value: U): Record<keyof T, U> => {
  return Object.fromEntries<U>(tuple.map((key) => [key, value])) as Record<keyof T, U>;
};
